<form [formGroup]="repairLocationFilterForm">
  <div class="form-content">
    <div class="pure-g">
      <div class="pure-u-md-12-24 p-b-12 p-r-16">
        <mc-multi-select
          label="Repair Location Code - Description"
          fit="medium"
          placeholder="Select an option"
          ngDefaultControl
          formControlName="repairLocationCodeList">
          @for (item of codeDescriptionList; track item.code) {
            <mc-option [attr.data-cy]="item.code" [value]="item.code + ' - ' + item.description">
              {{ item.code }} - {{ item.description }}
            </mc-option>
          }
        </mc-multi-select>
      </div>
    </div>
  </div>
</form>
